module.exports = __webpack_public_path__ + "static/media/rugby.d07459c6.jpg";